const riot = require('riot');
import '../assets/less/bulma-switch.min.css';
import './components/page/header.tag';
import './components/modal/toast.tag';
import './components/modal/modal.tag';
import preloader from '../lib/preloader';
import route from 'riot-route';
import config from '../../config/default.json'
import dconfig from '../../config/development.json'
import pconfig from '../../config/production.json'
import './pages/page-home.tag';
import './pages/page-login.tag';
import './pages/page-adstat.tag';
import './pages/page-apistat.tag';
import './pages/page-404.tag';
import './pages/page-customers.tag';
import './pages/page-properties.tag';
import './pages/page-audiences.tag';
import './pages/page-tagging.tag';
import './pages/page-campaigns.tag';
import './pages/page-users.tag';
import './pages/page-markets.tag';
import './pages/page-reports.tag';
riot.tag2('app', '<header data-is="page-header" if="{isLoggedIn}" section="{section}"></header> <section class="section has-margin"> <div class="container" data-is="{page}"> </div> </section> <toast></toast> <modal></modal>', 'app .has-margin,[data-is="app"] .has-margin{ padding: .75rem } app .strike,[data-is="app"] .strike{ text-decoration: line-through; } app .card-header-icon+.card-header-icon,[data-is="app"] .card-header-icon+.card-header-icon{ padding-left: 0; } app .level.is-fat .level-item,[data-is="app"] .level.is-fat .level-item{ padding: 0.5rem 0 } app .expandable,[data-is="app"] .expandable,app .is-collapse .card-header,[data-is="app"] .is-collapse .card-header{ cursor: pointer; } app .is-collapse .card-header:hover,[data-is="app"] .is-collapse .card-header:hover{ background: #f5f5f5; } app .is-flexwrap,[data-is="app"] .is-flexwrap{ flex-wrap: wrap } app .is-grow,[data-is="app"] .is-grow{ flex-grow:1 } app .is-shrink,[data-is="app"] .is-shrink{ flex-shrink:1 } app .is-flexwrap.is-grouped>.control,[data-is="app"] .is-flexwrap.is-grouped>.control{ margin-bottom: 1em !important } app .is-rounded,[data-is="app"] .is-rounded{ border-radius: 4px } app .is-list,[data-is="app"] .is-list{ padding-left: 20px } app .is-card,[data-is="app"] .is-card{ margin-bottom: 1rem; } app .tags.are-small .tag,[data-is="app"] .tags.are-small .tag{ font-size: 0.5rem; margin-top: 0.5em; } app .toggle-next .tags,[data-is="app"] .toggle-next .tags{ color: #909090; order: 3; flex: 1 1 100%; margin-top: 0.25em } app .toggle-next .tag,[data-is="app"] .toggle-next .tag{ padding-left: 0.25em; padding-right: 0.25em; margin-bottom: 0.25em } app .toggle-next,[data-is="app"] .toggle-next{ cursor: pointer; flex-wrap: wrap; } app .toggle-next:after,[data-is="app"] .toggle-next:after{ content: "(+)"; color: #909090; font-size: 80% } app .toggle-next.is-open:after,[data-is="app"] .toggle-next.is-open:after{ content: "(x)" } app .demography h4.title,[data-is="app"] .demography h4.title{ margin-top: 3em } app .dragging,[data-is="app"] .dragging{ outline: 2px dashed red } app proptable,[data-is="app"] proptable{ margin-left: 1em; display: block } app proptable .table,[data-is="app"] proptable .table{ margin-bottom: 1em; margin-top: 1em; font-size: 90%; } app .flex-shrink,[data-is="app"] .flex-shrink{ flex-basis: 30px !important } app .is-hover-red,[data-is="app"] .is-hover-red{ color: #909090; } app .is-hover-red:hover,[data-is="app"] .is-hover-red:hover{ color: red; } app .no-wrap,[data-is="app"] .no-wrap{ white-space: nowrap } app .break,[data-is="app"] .break{ break-before: page } app .is-pointer,[data-is="app"] .is-pointer{ cursor: pointer; pointer-events:all } app .is-max-height,[data-is="app"] .is-max-height{ max-height: 400px; overflow-y: auto; } app .xcolumns,[data-is="app"] .xcolumns{ display: flex; flex-flow: row wrap; justify-content: flex-end } app .xcolumns.head,[data-is="app"] .xcolumns.head{ font-weight:bold; color:#909090; } app .editing,[data-is="app"] .editing,app .xcolumns:hover,[data-is="app"] .xcolumns:hover{ background: #efefef; } app .xcolumns>div,[data-is="app"] .xcolumns>div{ padding: 0.25em; } app .xcolumn,[data-is="app"] .xcolumn{ flex: 0 0 90px; padding: 0.25em; } app .xcolumn.metric,[data-is="app"] .xcolumn.metric{ text-align: right; } app *:not(.head) .metric span,[data-is="app"] *:not(.head) .metric span{ font-size: 70%; display: block; } app .column,[data-is="app"] .column{ max-width:100%; } app .time_limit label,[data-is="app"] .time_limit label{ width: 40px; } @media (max-width:767px) { app .xcolumn.is-half-desktop,[data-is="app"] .xcolumn.is-half-desktop,app .xcolumn.is-20-desktop,[data-is="app"] .xcolumn.is-20-desktop{ flex-basis: 100%; padding-bottom: 0 } app .metric,[data-is="app"] .metric{ padding-top: 0; color: #999 } } @media (min-width:768px) { app .xcolumn,[data-is="app"] .xcolumn{ flex: 1 1 90px; padding: 0.25em; } app .xcolumn.is-half-desktop,[data-is="app"] .xcolumn.is-half-desktop{ flex-basis: 50%; } app .xcolumn.is-20-desktop,[data-is="app"] .xcolumn.is-20-desktop{ flex-basis: 20%; } app .has-margin,[data-is="app"] .has-margin{ padding: 1.5rem } app .has-columns,[data-is="app"] .has-columns{ columns: 2 } app .is-card,[data-is="app"] .is-card{ break-inside: avoid-column; page-break-inside: avoid } } @media (min-width:1408px) { app .has-columns,[data-is="app"] .has-columns{ columns: 3 } }', '', function(opts) {


	if (process.env.NODE_ENV=='development') {
	Object.assign(config,dconfig)
	console.log('DEVELOPMENT')
	}

	if (process.env.NODE_ENV=='production') {
		Object.assign(config,pconfig)
		console.log('PRODUCTION')
	}

  Date.prototype.toISODate = function() {
    return this.toISOString().replace(/T.*$/,'')
  }

  api.set('config',config)
  api.set('filters',{})

  api.set('markets',[
    {_id:'sl',name:'Slovenija'},
    {_id:'hr',name:'Hrvaška'},
    {_id:'sr',name:'Srbija'},
    {_id:'ba',name:'Bosna in Hercegovina'},
    {_id:'me',name:'Črna gora'},
    {_id:'mk',name:'Makedonija'},
    {_id:'gr',name:'Grčija'},
    {_id:'hu',name:'Madžarska'},
    {_id:'bg',name:'Bolgarija'},
    {_id:'cz',name:'Češka'},
    {_id:'sk',name:'Slovaška'},
    {_id:'it',name:'Italija'},
    {_id:'es',name:'Španija'},
  ])

	const self = this;
	window.preloader = preloader;

  	self.conf = config

	const routes = {
		'': {
			title: 'Welcome to BEXrt',
			tag: 'page-home',

			preloader: true
		},
		'home': {
			title: 'Welcome to BEXrt',
			tag: 'page-home',

			preloader: true
		},
		'adstat': {
			title: 'Header bidding statistics',
			tag: 'page-adstat',

			preloader: true
		},
		'apistat': {
			title: 'API statistics',
			tag: 'page-apistat',

			preloader: true
		},
		'404': {
			title: 'Page not found',
			tag: 'page-404',

			preloader: true
		},
		'login': {
			title: 'Sign-in or Sign-up',
			tag: 'page-login',

			preloader: false
		},
		'customers': {
			title: 'BEXrt: Customers',
			tag: 'page-customers',

			preloader: true
		},
		'properties': {
			title: 'BEXrt: Properties',
			tag: 'page-properties',

			preloader: true
		},
		'audiences': {
			title: 'BEXrt: Audiences',
			tag: 'page-audiences',

			preloader: true
		},

		'targeting': {
			title: 'BEXrt: Targeting',
			tag: 'page-campaigns',

			preloader: true
		},
		'users': {
			title: 'BEXrt: Users',
			tag: 'page-users',

			preloader: true
		},
		'markets': {
			title: 'BEXrt: Markets overview',
			tag: 'page-markets',

			preloader: true
		},
		'reports': {
			title: 'BEXrt: Report manager',
			tag: 'page-reports',

			preloader: true
		}
	}

	function checkAuth(section = '') {
		if(section == 'login' && self.isLoggedIn) {
			route('home');
			return;
		}
		if(section != 'login' && !self.isLoggedIn) {
			route('login');
			return;
		}
		return true;
	}

	self.section = '';
	self.page = 'page-login';
	self.isLoggedIn = false;
	self.router_started = false;

	const router = route(function(...args) {

		const section = args[0];

		const conf = routes[section];
		if(!conf) return route('404');

		window.riotRoute = {
			'args': args.slice(1)
		}

				self.section = section;
				self.page = conf.tag;
				self.query = route.query();

				self.update();
				window.document.title = conf.title;

	});

	function start_router() {

		if(self.router_started) return;

		self.router_started = true;
		route.start(true);
	}

	self.on('mount', () => {

		api.authenticate()
			.then(r => {
				self.isLoggedIn = true;
        		api.set('user', r.user)
        		loadData();
				start_router();
				if(self.section == 'login') return route('home')
			})
			.catch(e => {
				self.isLoggedIn = false;
				api.set('user', null)
				start_router();
				route('login')
			});
	})
	self.on('unmount', () => router.stop());

	api.on('authenticated', (payload) => {

		console.log('authenticated',payload)
		self.isLoggedIn = !!payload.user

    	loadData();
    	api.set('user', payload.user)

	});

	api.on('logout', () => {

		self.isLoggedIn = false;
		self.update();

		if(self.section != 'login') route('login');
	})

	function loadData(accessToken) {
		const properties = {},
			measures = {},
			active = [];
		api.set('properties', {})
		api.set('measures', {})
		api.service('property-crate').find({
			query: {
				$limit: 1000
			}
		}).then(r => {
			console.log('got properties', r)
			r.forEach(p => {
				if(!(p.property_id in properties)) properties[p.property_id] = {
					id: p.property_id,
					name: p.description_en,
					active: active.indexOf(p.property_id) > -1,
					measures: {}
				}
				if(p['measure.property_measure_id']) {
					const property_id = p.property_id,
						measure_id = p['measure.property_measure_id'],
						measure_label = p['measure.label'],
						measure_name = p['measure.description_en'],
						parent_id = p['measure.parent_measure_id'],
						parent = parent_id ? properties[property_id].measures[parent_id] : null,
						measure = {
							id: measure_id,
							label: measure_label,
							name: measure_name,
							parent_id: parent_id,
							parent: parent,
							children: [],
							active: !p['measure.disabled'],
							property_label: p.property_label,
							property_id: property_id,
							property_name: p.description_en,
						}
					if(property_id == 22) {
						const tag = {}
						measure_label.split(/\|/g).forEach((m, i) => tag['tier_' + i] = m)
						measure.path = tag
						measure.field = 'iab_cats'
					} else {
						measure.path = measure_label
						measure.field = p.property_label
					}
					measures[measure_label] = measure
					properties[property_id].measures[measure_id] = measure
					if(parent) parent.children.push(measure)
				}
			})
			console.log('properties', properties)
			api.set('measures', measures)
			api.set('properties', properties)
			self.update()
		}).catch(e => {
			api.emit('toast', {
				type: 'danger',
				title: 'Error fetching properties',
				content: e.message
			})
			console.log('error properties', e)
		})
	}
});
